import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#202030",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M16.08 16.452H8.55M16.08 12.086H8.55M11.423 7.73H8.548",
      style: {"stroke":"inherit"}
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#202030",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "m16.28 2.4-8.02.004c-2.878.018-4.66 1.912-4.66 4.8v9.591C3.6 19.7 5.396 21.6 8.3 21.6l8.018-.003c2.879-.018 4.662-1.913 4.662-4.802v-9.59c0-2.904-1.797-4.805-4.7-4.805",
      "clip-rule": "evenodd",
      style: {"stroke":"inherit"}
    }, null, -1)
  ])))
}
export default { render: render }